export const data: { question: string; answer: JSX.Element }[] = [
  {
    question: 'How can I use Brain.fm to overcome procrastination?',
    answer: (
      <div>
        <p>
          {`We recommend the following steps. First, sit down with a bite-sized piece of work you need to do. Next, listen to Motivation mode for 5 minutes. You don’t need to start work at this time, just set your intention and plan your first steps. Finally, when you’re ready, start working! You can also switch into Deep Work mode at this time.`}
        </p>
      </div>
    ),
  },
  {
    question: 'How is Motivation mode different from other Brain.fm music?',
    answer: (
      <div>
        <p>
          {`Our Motivation mode is the most energizing and upbeat music we have, made to kickstart your dopaminergic system (the brain system responsible for that feeling of ‘wanting to get things done’). We recommend using Motivation mode to get started in the morning, or if your energy is lower than usual.`}
        </p>
      </div>
    ),
  },
  {
    question: 'What other tools does Brain.fm have to help me beat procrastination?',
    answer: (
      <div>
        <p>
          {`Other than Motivation mode music, Brain.fm has a built-in Pomodoro timer (work-rest-repeat). For example a 25 minute ‘sprint’ of work followed by a 5 minute break. This is a great tool to divide your work down into smaller pieces, which helps you approach intimidating tasks.`}
        </p>
      </div>
    ),
  },
];
